import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import CaseStudiesSection from '../components/CaseStudiesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import { cases } from '../data/mock';
import { useLang } from '../context/LanguageContext';

export default function CasesPage() {
  const { t } = useLang();
  return (
    <>
      <Header />
      <PageHeader title={t('page.cases')} breadcrumb={[t('page.crumb.cases')]} />
      <CaseStudiesSection limit={cases.length} />
      <TestimonialsSection />
      <Footer />
    </>
  );
}
